export default "__VITE_ASSET__CuVpTwAZ__"